import { DashBoardConfigure } from "features/dashBoard"
import { TargetListResult } from "interface/search/targetList"

export const KeyOfTargetListCategory = '@target-category-'
export const getAxisTitle = <T>(
	configure: DashBoardConfigure<T>,
	key: string,
	targetList: TargetListResult | undefined | null
) => {
	if (key.startsWith(KeyOfTargetListCategory)) {
		if (!targetList?.category) return undefined
		const sequence = parseInt(key.substring(KeyOfTargetListCategory.length))
    return targetList.category.find((category) => category.sequence === sequence)?.title
	}
	return configure.axis[key]?.title
}

export const KeyOfTargetListScore = '@target-score-'
export const getValueTitle = <T>(
	configure: DashBoardConfigure<T>,
	key: string,
	targetList: TargetListResult | undefined | null
) => {
	if (key.startsWith(KeyOfTargetListScore)) {
		if (!targetList?.score) return undefined
		const sequence = parseInt(key.substring(KeyOfTargetListScore.length))
		return targetList.score.find((score) => score.sequence === sequence)?.title
	}
	return configure.value[key]?.title
}